import type { CommunityId } from 'domain/CommunityId';

// Owns the key format so the read in `setPreferredCommunity` and the write in the community
// listener cannot drift: a mismatch silently lands the user in the wrong community rather
// than failing. Existing users hold a numeric id here, so the format must not change.
const preferredCommunityKey = (accountId: number | undefined) => `preferredCommunityId-user${accountId}`;

export const getPreferredCommunityId = (accountId: number | undefined): CommunityId | null =>
  localStorage.getItem(preferredCommunityKey(accountId));

export const setPreferredCommunityId = (accountId: number | undefined, communityId: CommunityId): void => {
  localStorage.setItem(preferredCommunityKey(accountId), communityId);
};
